import React from "react";
import "../css/SendResultModal.css";

/** result: { sent: number, failed: string[], error?: boolean } */
const SendResultModal = ({ result, onClose }) => {
  if (!result) return null;
  const { sent, failed = [], error } = result;

  const title = error
    ? "Sending failed"
    : failed.length
      ? "Some emails could not be sent"
      : "Email sent";

  return (
    <div
      className="send-result-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="send-result-box" role="dialog" aria-modal="true" aria-label={title}>
        <button type="button" className="send-result-close" aria-label="Close" onClick={onClose}>
          &times;
        </button>
        <h5 className="send-result-title">{title}</h5>
        {error ? (
          <p className="send-result-text">Your email could not be sent. Please try again.</p>
        ) : (
          <>
            {sent > 0 && (
              <p className="send-result-text">
                {sent === 1
                  ? "Your email has been sent."
                  : `Your emails have been sent to ${sent} recipients.`}
              </p>
            )}
            {failed.length > 0 && (
              <>
                <p className="send-result-text">Could not be sent to {failed.length}:</p>
                <ul className="send-result-list">
                  {failed.map((name, i) => (
                    <li key={`${name}-${i}`}>{name}</li>
                  ))}
                </ul>
              </>
            )}
          </>
        )}
        <div className="send-result-actions">
          <button type="button" className="send-result-done" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default SendResultModal;
